const translations = {
  "en": {
    " in the App Store now.": " in the App Store now.",
    "One last step...": "One last step...",
    "please manually cancel your old subscription": "please manually cancel your old subscription",
    "Your Lifetime plan is active! To avoid any future charges,": "Your Lifetime plan is active! To avoid any future charges,"
  },
  "zh-tw": {
    " in the App Store now.": "現在在 App Store 上。",
    "One last step...": "最後一步...",
    "please manually cancel your old subscription": "請手動取消你的舊訂閱",
    "Your Lifetime plan is active! To avoid any future charges,": "你的終身方案已啟用！為避免未來產生費用，"
  }
};

export default translations;
